import { toast } from 'react-toastify';

export const getErrorMessage = (error: any, message?: string): string => {
  if (error) {
    if (error.message) {
      return `${message}' '  ${error.message}`;
    }
    if ('data' in error) {
      if (error.data.message) {
        return `${message}' '  ${error.data.message}`;
      }
      return `${message} ' '  ${JSON.stringify(error.data)}`;
    }

    if (message) {
      return message;
    }
  }
  return 'Error Occured';
};

export const downloadFile = async (fileUrl: string, fileName: string) => {
  if (fileUrl) {
    try {
      const response = await fetch(fileUrl, {
        method: 'GET'
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success('File downloaded successfully');
    } catch (error) {
      toast.error('File download failed');
    }
  }
};

export const viewPresignedUrlInNewTab = async (presignedUrl: string) => {
  if (!presignedUrl) return;
  try {
    window.open(presignedUrl, '_blank', 'noopener,noreferrer');
  } catch {
    toast.error('Failed to open the file');
  }
};
